const ImpressumPage = () => {
  return (
    <div data-testid="impressum-page" style={{ backgroundColor: '#372d24' }}>
      {/* Hero Section */}
      <section className="pt-12 pb-6" style={{ backgroundColor: '#372d24' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Impressum
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-8 pb-16" style={{ backgroundColor: '#372d24' }}>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-invert max-w-none">
            <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Angaben gemäß § 5 TMG
            </h2>
            
            <div className="p-6 rounded-lg mb-8 border border-[#4a3d32]" style={{ backgroundColor: '#2a2219' }}>
              <p className="mb-0" style={{ color: '#dbcebe' }}>
                <strong style={{ color: '#dbcebe' }}>Bastian Ebbecke - Trockenbau</strong><br />
                Tornower Dorfstr. 4<br />
                16225 Eberswalde<br />
                Deutschland
              </p>
            </div>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Kontakt
            </h3>
            <p style={{ color: '#a89f94' }}>
              Telefon: +49 162 1608568<br />
              E-Mail: info@trockenbau-be.de
            </p>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Umsatzsteuer-ID
            </h3>
            <p style={{ color: '#a89f94' }}>
              Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
              [Wird noch ergänzt]
            </p>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Berufsbezeichnung und berufsrechtliche Regelungen
            </h3>
            <p style={{ color: '#a89f94' }}>
              Berufsbezeichnung: Trockenbauer<br />
              Zuständige Kammer: Handwerkskammer Frankfurt (Oder) - Region Ostbrandenburg
            </p>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h3>
            <p style={{ color: '#a89f94' }}>
              Bastian Ebbecke<br />
              Tornower Dorfstr. 4<br />
              16225 Eberswalde
            </p>

            <h2 className="text-2xl font-bold mt-12 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Haftungsausschluss
            </h2>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Haftung für Inhalte
            </h3>
            <p style={{ color: '#a89f94' }}>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
            </p>
            <p style={{ color: '#a89f94' }}>
              Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p style={{ color: '#a89f94' }}>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Haftung für Links
            </h3>
            <p style={{ color: '#a89f94' }}>
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p style={{ color: '#a89f94' }}>
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Urheberrecht
            </h3>
            <p style={{ color: '#a89f94' }}>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
            <p style={{ color: '#a89f94' }}>
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ImpressumPage;
